const baseSize = 16

function setRem() {
  const scale = document.documentElement.clientWidth / 900
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
}

if (document.documentElement.clientWidth < 900) {
  setRem()
}
function onResize() {
  const width = document.documentElement.clientWidth
  if (width <= 900) {
    setRem()
  } else {
    document.documentElement.style.fontSize = baseSize + 'px'
  }
}
window.onresize = onResize
